import { ApplicantsWrapper } from "Components/Applicants";
import { ApplicantComments } from "Components/Applicants/ApplicantProfile/ApplicantComments";
import { ApplicantProfile } from "Components/Applicants/ApplicantProfile/ApplicantProfile";
import { ApplicantQuestions } from "Components/Applicants/ApplicantProfile/ApplicantQuestions";
import { ApplicantResume } from "Components/Applicants/ApplicantProfile/ApplicantResume";
import { ApplicantStage } from "Components/Applicants/ApplicantProfile/ApplicantStage";
import { ApplicantWrapper } from "Components/Applicants/ApplicantProfile/ApplicantWrapper";
import { IncompleteApplicants } from "Components/Applicants/IncompleteApplicants";
import { AuthV2 } from "Components/AuthV2/AuthV2";
import { Calendar } from "Components/Calendar/Calendar";
import { Bundles } from "Components/CreateJob/Bundles";
import { CreateJob } from "Components/CreateJob/CreateJob";
import { JobDetails } from "Components/CreateJob/JobDetails";
import { JobPreview } from "Components/CreateJob/JobPreview";
import { JobTitle } from "Components/CreateJob/JobTitle";
import { Payment } from "Components/CreateJob/Payment";
import { PaymentRedirect } from "Components/CreateJob/PaymentRedirect";
import { Dashboard } from "Components/Dashboard/Dashboard";
import { CanIGetHelp } from "Components/Help";
import { DoesITWork } from "Components/Help/DoesITWork";
import { Help } from "Components/Help/Help";
import { IsItEasy } from "Components/Help/IsItEasy";
import { IsItFast } from "Components/Help/IsItFast";
import { LotOfCandidates } from "Components/Help/LotOfCandidates";
import { Welcome } from "Components/Help/Welcome";
import { WhatDoIGet } from "Components/Help/WhatDoIGet";
import { WhatDoesItCost } from "Components/Help/WhatDoesItCost";
import { WhatIsSH } from "Components/Help/WhatIsSH";
import { Interviews } from "Components/Interviews/Interviews";
import { JobsWrapper } from "Components/JobsTs/JobsWrapper";
import { AccessLevels } from "Components/SettingsTs/AccessLevels";
import { AccountInfo } from "Components/SettingsTs/AccountInfo";
import { CompanyInfo } from "Components/SettingsTs/CompanyInfo";
import { Security } from "Components/SettingsTs/Security/Security";
import { Settings } from "Components/SettingsTs/Settings";
import AppLayout from "layouts/AppLayout/AppLayout";
import { Navigate, Route, Routes } from "react-router-dom";

export const EmployerRouter = () => {
    return (<>
        <Routes>
            <Route element={<AuthV2 appContext="employer" />}>
                {/* Main app layout */}
                <Route path="/" element={<AppLayout />}>
                    {/* Dashboard */}
                    <Route path="/dashboard" element={<Dashboard />} >

                    </Route>

                    {/* Calendar */}
                    <Route path="/calendar" element={<Calendar />} />

                    {/* Help */}
                    <Route path="/help" element={<Help />} />
                    <Route path="/help/welcome" element={<Welcome />} />
                    <Route path="/help/what-is-smoothhiring" element={<WhatIsSH />} />
                    <Route path="/help/is-it-easy" element={<IsItEasy />} />
                    <Route path="/help/is-it-fast" element={<IsItFast />} />
                    <Route path="/help/what-does-it-cost" element={<WhatDoesItCost />} />
                    <Route path="/help/lots-of-candidates" element={<LotOfCandidates />} />
                    <Route path="/help/what-do-i-get" element={<WhatDoIGet />} />
                    <Route path="/help/does-it-work" element={<DoesITWork />} />
                    <Route path="/help/can-i-get-help" element={<CanIGetHelp />} />

                    {/* Jobs List */}
                    {["/jobs/draft", "/jobs/active", "/jobs/expired"].map((path, key) =>
                        (<Route path={path} element={<JobsWrapper />} key={key} />))}
                    <Route path="/jobs" element={<Navigate replace to="/employer/jobs/active" />} />

                    {/* Interviews */}
                    {["/interviews/scheduled", "/interviews/completed", "/interviews/cancelled"].map((path, key) =>
                        (<Route path={path} element={<Interviews />} key={key} />))}
                    <Route path="/interviews" element={<Navigate replace to="/employer/interviews/scheduled" />} />

                    {/* Job Creation */}
                    <Route path="/job" element={<CreateJob />} >
                        <Route path="/job/new" element={<Navigate replace to="/employer/job/new/title" />} />
                        <Route path="/job/:jobId" element={<Navigate replace to="/employer/job/:jobId/title" />} />
                        <Route path="/job/:jobId/title" element={<JobTitle />} />
                        <Route path="/job/:jobId/details" element={<JobDetails />} />
                        <Route path="/job/:jobId/preview" element={<JobPreview />} />
                        <Route path="/job/:jobId/bundles" element={<Bundles />} />
                        <Route path="/job/:jobId/payment" element={<Payment />} >
                            <Route path="/job/:jobId/payment/success" element={<PaymentRedirect />} />
                            <Route path="/job/:jobId/payment/failed" element={<PaymentRedirect />} />
                        </Route>
                    </Route>

                    {/* Settings */}
                    <Route path="/settings" element={<Settings />} >
                        <Route path="/settings" element={<Navigate replace to="/employer/settings/account-information" />} />
                        <Route path="/settings/account-information" element={<AccountInfo />} />
                        <Route path="/settings/company-information" element={<CompanyInfo />} />
                        <Route path="/settings/access-levels" element={<AccessLevels />} />
                        <Route path="/settings/security" element={<Security />} />
                        <Route path="/settings/branding" element={<></>} />
                        <Route path="/settings/integrations" element={<></>} />
                    </Route>

                    {/* Applicants */}
                    <Route path="/applicants/:jobId" element={<ApplicantsWrapper />} />

                    {/* Incomplete Applicants */}
                    <Route path="/incomplete-applicants/:jobId" element={<IncompleteApplicants />} />

                    {/* Applicant */}
                    <Route path="/job/:jobId/applicant" element={<ApplicantWrapper />} >
                        <Route path="/job/:jobId/applicant"
                            element={<Navigate replace to="/employer/job/:jobId/applicant/:applicantId/profile" />} />
                        <Route path="/job/:jobId/applicant/:applicantId/profile" element={<ApplicantProfile />} />
                        <Route path="/job/:jobId/applicant/:applicantId/resume" element={<ApplicantResume />} />
                        <Route path="/job/:jobId/applicant/:applicantId/comments" element={<ApplicantComments />} />
                        <Route path="/job/:jobId/applicant/:applicantId/questions" element={<ApplicantQuestions />} />
                        <Route path="/job/:jobId/applicant/:applicantId/stage" element={<ApplicantStage />} />
                    </Route>
                </Route>
            </Route>
        </Routes>
    </>)
}